//this file is being processed by the build-env.js to replace process.env_SOME_VARIABLE with its string or object value

export const environment = {
  environmentAlias: "test",
  firebaseConfig: {"apiKey":"AIzaSyALf6U2bA17GOEmmnEqWMqlWade-MksQuU","appId":"1:755444940492:web:e56e458a555159a7e74c69","authDomain":"ball-score-test.firebaseapp.com","databaseURL":"","messagingSenderId":"755444940492","projectId":"ball-score-test","storageBucket":"ball-score-test.appspot.com"},
  release: "ball-score@2.23.2-test+build.2026-09-11T20-20-59",
};
